/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class Constants {
    public static OPEN_API_20_DEFAULT_VERSION : string = "2.0";

    public static OPEN_API_30_DEFAULT_VERSION : string = "3.0.2";

    public static ASYNC_API_20_DEFAULT_VERSION : string = "2.0.0";

    public static EXTENSION_PREFIX : string = "x-";

    public static PROP_ASYNCAPI : string = "asyncapi";

    public static PROP_OPENAPI : string = "openapi";

    public static PROP_SWAGGER : string = "swagger";

    public static PROP_ID : string = "id";

    public static PROP_TRACE : string = "trace";

    public static PROP_PATCH : string = "patch";

    public static PROP_HEAD : string = "head";

    public static PROP_OPTIONS : string = "options";

    public static PROP_DELETE : string = "delete";

    public static PROP_POST : string = "post";

    public static PROP_PUT : string = "put";

    public static PROP_GET : string = "get";

    public static PROP_SERVER : string = "server";

    public static PROP_REQUEST_BODY : string = "requestBody";

    public static PROP_OPERATION_ID : string = "operationId";

    public static PROP_OPERATION_REF : string = "operationRef";

    public static PROP_SCOPES : string = "scopes";

    public static PROP_REFRESH_URL : string = "refreshUrl";

    public static PROP_TOKEN_URL : string = "tokenUrl";

    public static PROP_AUTHORIZATION_URL : string = "authorizationUrl";

    public static PROP_AUTHORIZATION_CODE : string = "authorizationCode";

    public static PROP_CLIENT_CREDENTIALS : string = "clientCredentials";

    public static PROP_PASSWORD : string = "password";

    public static PROP_IMPLICIT : string = "implicit";

    public static PROP_OPEN_ID_CONNECT_URL : string = "openIdConnectUrl";

    public static PROP_FLOW : string = "flow";

    public static PROP_FLOWS : string = "flows";

    public static PROP_BEARER_FORMAT : string = "bearerFormat";

    public static PROP_SCHEME : string = "scheme";

    public static PROP_EXTERNAL_VALUE : string = "externalValue";

    public static PROP_VALUE : string = "value";

    public static PROP_PARSE_VALUE : string = "parseValue";

    public static PROP_SUMMARY : string = "summary";

    public static PROP_ALLOW_EMPTY_VALUE : string = "allowEmptyValue";

    public static PROP_IN : string = "in";

    public static PROP_ALLOW_RESERVED : string = "allowReserved";

    public static PROP_EXPLODE : string = "explode";

    public static PROP_STYLE : string = "style";

    public static PROP_CONTENT_TYPE : string = "contentType";

    public static PROP_ENCODING : string = "encoding";

    public static PROP_SCHEMA : string = "schema";

    public static PROP_CONTENT : string = "content";

    public static PROP_MAPPING : string = "mapping";

    public static PROP_PROPERTY_NAME : string = "propertyName";

    public static PROP_WRAPPED : string = "wrapped";

    public static PROP_ATTRIBUTE : string = "attribute";

    public static PROP_PREFIX : string = "prefix";

    public static PROP_NAMESPACE : string = "namespace";

    public static PROP_DEPRECATED : string = "deprecated";

    public static PROP_WRITE_ONLY : string = "writeOnly";

    public static PROP_NULLABLE : string = "nullable";

    public static PROP_DISCRIMINATOR : string = "discriminator";

    public static PROP_ANY_OF : string = "anyOf";

    public static PROP_ONE_OF : string = "oneOf";

    public static PROP_EXAMPLE : string = "example";

    public static PROP_XML : string = "xml";

    public static PROP_READ_ONLY : string = "readOnly";

    public static PROP_ADDITIONAL_PROPERTIES : string = "additionalProperties";

    public static PROP_PROPERTIES : string = "properties";

    public static PROP_ALL_OF : string = "allOf";

    public static PROP_NOT : string = "not";

    public static PROP_ITEMS : string = "items";

    public static PROP_TYPE : string = "type";

    public static PROP_REQUIRED : string = "required";

    public static PROP_COLLECTION_FORMAT : string = "collectionFormat";

    public static PROP_MIN_PROPERTIES : string = "minProperties";

    public static PROP_MAX_PROPERTIES : string = "maxProperties";

    public static PROP_UNIQUE_ITEMS : string = "uniqueItems";

    public static PROP_MIN_ITEMS : string = "minItems";

    public static PROP_MAX_ITEMS : string = "maxItems";

    public static PROP_PATTERN : string = "pattern";

    public static PROP_MIN_LENGTH : string = "minLength";

    public static PROP_MAX_LENGTH : string = "maxLength";

    public static PROP_EXCLUSIVE_MINIMUM : string = "exclusiveMinimum";

    public static PROP_MINIMUM : string = "minimum";

    public static PROP_EXCLUSIVE_MAXIMUM : string = "exclusiveMaximum";

    public static PROP_MAXIMUM : string = "maximum";

    public static PROP_MULTIPLE_OF : string = "multipleOf";

    public static PROP_FORMAT : string = "format";

    public static PROP_$REF : string = "$ref";

    public static PROP_CALLBACKS : string = "callbacks";

    public static PROP_LINKS : string = "links";

    public static PROP_SECURITY_SCHEMES : string = "securitySchemes";

    public static PROP_HEADERS : string = "headers";

    public static PROP_REQUEST_BODIES : string = "requestBodies";

    public static PROP_EXAMPLES : string = "examples";

    public static PROP_PARAMETERS : string = "parameters";

    public static PROP_RESPONSES : string = "responses";

    public static PROP_SCHEMAS : string = "schemas";

    public static PROP_DEFAULT : string = "default";

    public static PROP_ENUM : string = "enum";

    public static PROP_VARIABLES : string = "variables";

    public static PROP_EMAIL : string = "email";

    public static PROP_URL : string = "url";

    public static PROP_NAME : string = "name";

    public static PROP_VERSION : string = "version";

    public static PROP_LICENSE : string = "license";

    public static PROP_CONTACT : string = "contact";

    public static PROP_TERMS_OF_SERVICE : string = "termsOfService";

    public static PROP_DESCRIPTION : string = "description";

    public static PROP_TITLE : string = "title";

    public static PROP_COMPONENTS : string = "components";

    public static PROP_PATHS : string = "paths";

    public static PROP_TAGS : string = "tags";

    public static PROP_SECURITY : string = "security";

    public static PROP_SERVERS : string = "servers";

    public static PROP_EXTERNAL_DOCS : string = "externalDocs";

    public static PROP_INFO : string = "info";

    public static PROP_HOST : string = "host";

    public static PROP_BASE_PATH : string = "basePath";

    public static PROP_SCHEMES : string = "schemes";

    public static PROP_CONSUMES : string = "consumes";

    public static PROP_PRODUCES : string = "produces";

    public static PROP_DEFINITIONS : string = "definitions";

    public static PROP_SECURITY_DEFINITIONS : string = "securityDefinitions";

    public static PROP_REF : string = "ref";

    public static PROP_REFS : string = "refs";

    public static PROP_METHOD : string = "method";

    public static PROP_CALLBACK_URL_EXPRESSION : string = "callbackUrlExpression";

    public static PROP_OPERATIONS : string = "operations";

    public static PROP_EXTENSIONS : string = "extensions";

    public static PROP_EXPRESSION : string = "expression";

    public static PROP_HIDDEN : string = "hidden";

    public static PROP_MEDIA_TYPE : string = "mediaType";

    public static PROP_REQUIRED_PROPERTIES : string = "requiredProperties";

    public static PROP_DEFAULT_VALUE : string = "defaultValue";

    public static PROP_DISCRIMINATOR_MAPPING : string = "discriminatorMapping";

    public static PROP_SECURITY_SCHEME_NAME : string = "securitySchemeName";

    public static PROP_API_KEY_NAME : string = "apiKeyName";

    public static PROP_RESPONSE_CODE : string = "responseCode";

    public static PROP_IMPLEMENTATION : string = "implementation";

    public static PROP_ENUMERATION : string = "enumeration";

    public static PROP_CHANNELS : string = "channels";

    public static PROP_PROTOCOL : string = "protocol";

    public static PROP_PROTOCOL_VERSION : string = "protocolVersion";

    public static PROP_MESSAGES : string = "messages";

    public static PROP___TYPE : string = "__type";

    public static PROP_OF : string = "of";

    public static PROP_AS : string = "as";

    public static PROP_BINDINGS : string = "bindings";

    public static PROP_SERVER_BINDINGS : string = "serverBindings";

    public static PROP_CHANNEL_BINDINGS : string = "channelBindings";

    public static PROP_MESSAGE_BINDINGS : string = "messageBindings";

    public static PROP_OPERATION_BINDINGS : string = "operationBindings";

    public static REF_PREFIX_API_RESPONSE : string = "#/components/responses/";

    public static REF_PREFIX_CALLBACK : string = "#/components/callbacks/";

    public static REF_PREFIX_EXAMPLE : string = "#/components/examples/";

    public static REF_PREFIX_HEADER : string = "#/components/headers/";

    public static REF_PREFIX_LINK : string = "#/components/links/";

    public static REF_PREFIX_PARAMETER : string = "#/components/parameters/";

    public static REF_PREFIX_REQUEST_BODY : string = "#/components/requestBodies/";

    public static REF_PREFIX_SCHEMA : string = "#/components/schemas/";

    public static REF_PREFIX_SECURITY_SCHEME : string = "#/components/securitySchemes/";

    public static PROP_CORRELATION_IDS : string = "correlationIds";

    public static PROP_TRAITS : string = "traits";

    public static PROP_MESSAGE_TRAITS : string = "messageTraits";

    public static PROP_OPERATION_TRAITS : string = "operationTraits";

    public static PROP_MESSAGE : string = "message";

    public static PROP_CORRELATION_ID : string = "correlationId";

    public static PROP_TRAIT_EXTENDED_ITEMS : string = "_traitExtendedItems";

    public static PROP_TRAIT_ITEMS : string = "_traitItems";

    public static PROP_SUBSCRIBE : string = "subscribe";

    public static PROP_PUBLISH : string = "publish";

    public static PROP_PAYLOAD : string = "payload";

    public static PROP_SCHEMA_FORMAT : string = "schemaFormat";

    public static PROP_LOCATION : string = "location";

    public static PROP_DEFAULT_CONTENT_TYPE : string = "defaultContentType";

    public static PROP__TRAIT : string = "_trait";

    public static PROP__OPERATION_TRAIT : string = "_operationTrait";

    public static PROP_HTTP : string = "http";

    public static PROP_WS : string = "ws";

    public static PROP_KAFKA : string = "kafka";

    public static PROP_AMQP : string = "amqp";

    public static PROP_AMQP1 : string = "amqp1";

    public static PROP_MQTT : string = "mqtt";

    public static PROP_MQTT5 : string = "mqtt5";

    public static PROP_NATS : string = "nats";

    public static PROP_JMS : string = "jms";

    public static PROP_SNS : string = "sns";

    public static PROP_SQS : string = "sqs";

    public static PROP_STOMP : string = "stomp";

    public static PROP_REDIS : string = "redis";
}
Constants["__class"] = "io.apicurio.datamodels.core.Constants";



